const UIBox = require("./card/box.css")
const UIButton = require("./button/button.css")
const UIButtonImage = require("./button/button-image.css")
const UIButtonPix = require("./button/button-pix.css")
const UIButtonInvoice = require("./button/button-invoice.css")
const UICard = require("./card/card.css")
const UIContextMenu = require("./context-menu/index.css")
const UILink = require("./link/index.css")
const UIList = require("./list/index.css")
const UIDefinition = require("./list/definition.css")
const UISummary = require("./list/summary.css")
const UIToolbar = require("./toolbar/index.css")
const UIPrompt = require("./prompt/index.css")
const UIInput = require("./input/index.css")
const UIForm = require("./form/index.css")
const UIModal = require("./modal/index.css")
const UIFloatLabel = require("./floatLabel/index.css")
const UIRadioButton = require("./radioButton/index.css")
const UIEmptyState = require("./emptyState/emptyState.css")
const UIBullets = require("./bullets/index.css")
const UIFloatLabelAddTicket = require("./floatLabelAddTicket/index.css")
const UIHeader = require("./header/index.css")
const UILinkText = require("./typograph/link/index.css")
const UITypograph = require("./typograph/index.css")
const UIDefaultContainer = require("./defaultContainer/index.css")
const UIMenu = require("./menu/index.css")
const UITypoItem = require("./typograph/item/index.css")
const UITypoSubitem = require("./typograph/subitem/index.css")
const UITypoIconlink = require("./typograph/iconlink/index.css")
const UIContainerGradient = require("./containerGradient/index.css")
const UIModernButton = require("./modernButton/index.css")
const UICardButton = require("./cardButton/index.css")
const UIDefaultTitle = require("./defaultTitle/index.css")
const UIToast = require("./toast/index.css")
const UIInvoicesPaid = require("./invoicesPaid/index.css")
const UIBanner = require("./banner/index.css")
const UIDescriptionInvoiceHeader = require("./descriptionInvoiceHeader/index.css")
const UIModernModal = require("./modernModal/index.css")
const UIInvoicesOptions = require("./invoicesOptions/index.css")
const UIModernFloatLabel = require("./modernFloatLabel/index.css")
const UIModernSelect = require("./ModernSelect")
const UIGeneralProductInformation = require("./generalProductInformation/index.css")
const UISelectMulti = require("./SelectMulti/index.css")
const UIReactDateRange = require("./reactDatesRange/index.css")
const UITextInformartionBand = require("./TextInformartionBand/index.css")
const UICustomerRegister = require("./customerRegister/index.css")
const UIDescriptionList = require("./descriptionList/index.css")
const UIInputTextArea = require("./InputTextArea/index.css")
const UIContractAndOrders = require("./contractAndOrders/index.css")

module.exports = {
  UIBox,
  UIButton,
  UIButtonImage,
  UIButtonPix,
  UIButtonInvoice,
  UICard,
  UIContextMenu,
  UIDefinition,
  UIFloatLabel,
  UIFloatLabelAddTicket,
  UIForm,
  UIInput,
  UILink,
  UIList,
  UIModal,
  UIPrompt,
  UISummary,
  UIToolbar,
  UIRadioButton,
  UIEmptyState,
  UIBullets,
  UIHeader,
  UILinkText,
  UITypograph,
  UIDefaultContainer,
  UIMenu,
  UITypoItem,
  UITypoSubitem,
  UITypoIconlink,
  UIContainerGradient,
  UIModernButton,
  UICardButton,
  UIDefaultTitle,
  UIToast,
  UIInvoicesPaid,
  UIBanner,
  UIDescriptionInvoiceHeader,
  UIModernModal,
  UIInvoicesOptions,
  UIModernFloatLabel,
  UIModernSelect,
  UIGeneralProductInformation,
  UISelectMulti,
  UIReactDateRange,
  UITextInformartionBand,
  UICustomerRegister,
  UIDescriptionList,
  UIInputTextArea,
  UIContractAndOrders
}



// WEBPACK FOOTER //
// ./src/shared/skin/styles/index.js